import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import { axiosClient } from "../query/axiosClient";
import { REPORTS } from "../configs/endpoints";

const fetchReports = async (pageSize, pageIndex) => {
    const url = REPORTS.REPORTS_LIST(pageSize, pageIndex);
    const { data } = await axiosClient.get(url);
    return data;
}

export const useReports = (pageSize) => {
    return useInfiniteQuery({
        queryKey: ['reports', pageSize],
        queryFn: ({ pageParam = 0 }) => fetchReports(pageSize, pageParam),
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages) => {
            if (lastPage.content.length < pageSize) return undefined;
            return allPages.length;
        },
        refetchOnMount: "always"
    });
}

export const createReport = async (reportData) => {
    const url = REPORTS.REPORTS_CREATE();
    const { data } = await axiosClient.post(url, reportData);
    return data;
}

export const downloadReport = async (id) => {
    const url = REPORTS.REPORTS_DOWNLOAD(id);
    const { data } = await axiosClient.get(url);
    return data; // Pode retornar a signed URL diretamente (ex: data.url)
}
